import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import en from "../locales/en"
import es from "../locales/es"

// Single shared i18next instance for the whole app. Locale is decided
// server-side (user.locale -> organization.locale -> :en) and delivered as the
// `locale` Inertia shared prop; entrypoints/inertia.tsx seeds this instance
// from it on boot and re-syncs on every Inertia navigation. There is no
// browser language detector — the user's stored preference is authoritative.
//
// `lng: "en"` is only the pre-hydration default; inertia.tsx immediately calls
// changeLanguage() with the server-resolved locale before first paint concerns
// matter. Missing `es` keys fall back to English (fallbackLng).
void i18next.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: "en",
  fallbackLng: "en",
  returnNull: false,
  interpolation: {
    // React already escapes rendered values; double-escaping mangles copy.
    escapeValue: false,
  },
})

export default i18next
